module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('h2', {
    staticClass: "nobreak"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre8",
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "2",
      "summary": "table"
    }
  }, [_c('tbody', {
    staticClass: "calibre"
  }, [_c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Why Authors Go Wrong")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Barbaric Yawp")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("In the Critical Court")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Book “Reviewing”")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Literary Editors, by One of Them")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("What Every Publisher Knows")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Secret of the Best Seller")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre1"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Writing a Novel")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a46bc924","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0